import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/password/reset', '/password/forget', '/echarts/generateImage.html']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, routeCodes, accessRoutes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          //document.title = getPageTitle(to.meta.title)

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 35;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 8;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 33;
          break;
        case 8:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 13;
            break;
          }
          next();
          _context.next = 33;
          break;
        case 13:
          _context.prev = 13;
          _context.next = 16;
          return store.dispatch('user/getInfo');
        case 16:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          routeCodes = _yield$store$dispatch.routeCodes;
          _context.next = 21;
          return store.dispatch('permission/generateRoutes', {
            roles: roles,
            routeCodes: routeCodes
          });
        case 21:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 33;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](13);
          _context.next = 30;
          return store.dispatch('user/resetToken');
        case 30:
          Message.error(_context.t0 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 33:
          _context.next = 36;
          break;
        case 35:
          /* has no token*/
          // console.log('no token!!')
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            if (to.path.indexOf('dashboard') != -1) {
              next("/login");
            } else {
              next("/login?m=TOKEN_TIMEOUT");
            }
            NProgress.done();
          }
        case 36:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[13, 26]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});